export default __webpack_public_path__ + "static/media/nftfar.7b5b79fc.gif";